<template>
  <layout-basic>
    <page-hero
      title="Employee Development"
      lead="Support continuous development from one platform."
    />

    <section class="demo-video-section">
      <v-container style="max-width: 960px">
        <demo-video video-key="features" />
      </v-container>
    </section>

    <point-grid
      title="Grow skills across your whole workforce"
      :points="points"
      :columns="2"
      tint
    />

    <!-- Trilogy Active (16 Sep 2026), verbatim. -->
    <quote-row :quotes="pageQuotes" />

    <standard-cta
      title="Ready to develop every employee?"
      lead="Watch the 5-minute demo or experience IMPROVE and see how learning pathways work."
    />
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import PageHero from '@/components/marketing/PageHero.vue';
import PointGrid from '@/components/marketing/PointGrid.vue';
import StandardCta from '@/components/marketing/StandardCta.vue';
import QuoteRow from '@/components/marketing/QuoteRow.vue';
import { TRILOGY_CPD } from '@/data/testimonials';
import DemoVideo from '@/components/DemoVideo.vue';
import { marketingPageMeta } from '@/utils/marketingPage';

export default {
  name: 'SolutionDevelopment',
  components: {
    LayoutBasic,
    PageHero,
    PointGrid,
    QuoteRow,
    StandardCta,
    DemoVideo,
  },
  metaInfo() {
    return marketingPageMeta({
      title: 'Employee Development | IMPROVE',
      description:
        'Grow skills across your workforce with continuous development on one simple platform.',
      path: '/solutions/employee-development',
    });
  },
  data() {
    return {
      pageQuotes: [TRILOGY_CPD],
      points: [
        'Learning pathways for every role',
        '130+ courses ready to assign',
        'Upload your own development content',
        'Engage employees with short, practical learning',
        'Track progress without spreadsheets',
        'Develop people alongside day-to-day work',
      ],
    };
  },
};
</script>
